import { HandlersCollection } from '@tblabs/truffle';
import { Socket } from 'socket.io-client';
import { ConnectionStatusEvent } from './ConnectionStatusEvent';
import { IServer } from './IServer';


export class DemoServer implements IServer
{
    public Socket: Socket;
    public IsConnected: boolean = false;
    public OnConnectionChange = new HandlersCollection<(event: ConnectionStatusEvent) => void>();

    private Log(...msg): void
    {
        // console.log('[DemoServer]', ...msg);
    }

    public get ServerId(): string
    {
        return "D1";
    }

    private SetConnectionStatus(isConnected: boolean, problem?: string): void
    {
        this.IsConnected = isConnected;
        const event = new ConnectionStatusEvent(this.IsConnected, problem);

        this.OnConnectionChange.Call(event);
    }

    public Init(): void
    { }

    public Connect(): void
    {
        const source = "https://photos.specteam.pl/tx-demo";
        this.Log(`Symulating connection. Using pics from ${source}.`);
        this.SetConnectionStatus(true);
    }

    public Disconnect()
    { }
}
